import { Either } from 'tsmonad';

import { ResponseTransformer } from './ResponseTransformer';

export const noTransform: ResponseTransformer = (response) => {
  /**
   * 요청 응답에 config 정보를 추가했으니 로깅을 마쳤다면 불필요한 정보를 응답에 포함하지 않도록 삭제한다
   * removeConfigTransform 을 새로 생성하는게 맞으나 noContentAsError, noContentAs404 같은
   * noTransform 을 확장한 transform 을 사용중이기 때문에 이 transformer 의 이름을 변경하는것이 맞는것으로 보인다
   * TODO: renaming from noTransform to removeConfigTransform or defaultTransform
   */
  delete response.config;
  return response.success ? Either.right(response) : Either.left(response);
};
